document.addEventListener('DOMContentLoaded', function () {
  // === Добавление в корзину ===
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const variantId = this.getAttribute('data-variant-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added:', data);
        updateFreeShippingProgress();

        // 🟢 Обновляем мини-корзину вручную
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data }
        }));
      })
      .catch(error => console.error('Error adding product:', error));
    });
  });

  // === Обновление прогресса бесплатной доставки ===
  function updateFreeShippingProgress() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const threshold = 75000;
        const total = cart.total_price;
        const remaining = threshold - total;

        const msg = document.getElementById('free-shipping-message');
        const bar = document.getElementById('progress-bar-fill');

        if (remaining > 0) {
          msg.textContent = `Add $${(remaining / 100).toFixed(2)} more for free shipping`;
          bar.style.width = `${Math.min((total / threshold) * 100, 100)}%`;
        } else {
          msg.textContent = `You have qualified for free shipping! 🎉`;
          bar.style.width = `100%`;
        }
      });
  }

  // === Слайдер со стрелками (если есть) ===
  const carousel = document.querySelector('.related-products-carousel');
  const prev = document.querySelector('.slider-prev');
  const next = document.querySelector('.slider-next');

  if (carousel && prev && next) {
    prev.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      carousel.scrollBy({ left: -300, behavior: 'smooth' });
    });

    next.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      carousel.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }
});
